import { EnquiryTenantSettingsDto } from '@careapp-group/ng-sdk';
import { CaEntityState } from '../../../store/entity-state/entity-state';
import { CaEntityReducer } from '../../../store/entity-state/entity-reducer';
import { BaseFilterType } from '../../../store/entity-state/entity-actions-factory';
import { EnquiriesTenantSettings } from './enquiries-tenant-settings.actions';

export interface EnquiriesTenantSettingsState extends CaEntityState<EnquiryTenantSettingsDto> {}

export class EnquiriesSettingsReducer extends CaEntityReducer<
  EnquiryTenantSettingsDto,
  BaseFilterType
> {}

export const state = new EnquiriesSettingsReducer(EnquiriesTenantSettings);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
